import { axiosInstance } from '@/lib/axios'
import {
  WebfleetBorderPreviewRequest,
  WebfleetBorderPreviewResponse,
} from './types'

type Props = {
  companyId: string
  payload: WebfleetBorderPreviewRequest
}

export function previewWebfleetBorders({ companyId, payload }: Props) {
  return axiosInstance.post<WebfleetBorderPreviewResponse>(
    `/api/${companyId}/webfleet/borders/preview`,
    payload,
  )
}
